import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../_models';
import { StoryDetails } from '../admin-common/story/story.component';
export interface AddAdminDetails { 
    name: string; 
    email:string;
    mobile: number;
    zip:string;
    state:string;
    city:string;
    aadhar_number:string;
    superadmin_id:number;
    username:string;
    password: string;
  }
  
export interface UpdateAdminDetails { 
    id: number;
    name: string; 
    email:string;
    mobile: number;
    zip:string;
    state:string;
    city:string;
    aadhar_number:string;
}
export interface UpdateProfile { 
    id: number;
    name: string; 
    email:string;
    mobile: number;
    zip:string;
    state:string;
    city:string;
    aadhar_number:string;
    profile_image:string;
}
export interface UpdateAdminPassword { 
    current_password:string;
    new_password:string;
}
export interface AddSubscriptionDetails {
    admin_id:number;
    price: number;
    name: string; 
    description: string;
    days:number;
}
export interface UpdateSubscriptionDetails {
    id:number;
    price: number;
    name: string; 
    description: string;
    days:number;
}
export interface AddStoryDetails {
    admin_id:number;
    title:string;
    description:string; 
    story_image:string;
}
export interface UpdateStoryDetails {
    id:number;
    title:string;
    description:string; 
    story_image:string;
}
export interface AdminID {
    admin_id: number,
}
export interface SubscriptionID {
    subscription_id: number,
}
export interface StoryID {
    story_id: number,
}
export interface UserID {
    user_id: number,
}
export interface ChangeStatus{
    user_id:number,
    status:number
}
export interface DownloadData{
    start_date:string,
    end_date:string
}
@Injectable({ providedIn: 'root' })

export class AdminService {
    public baseUrl="https://access.vaishyasabhamumbaivivah.com";
    private key = "eyJjdCI6InJkZll2SDd0WGtvZVJ2Y3I3RTZSb1k5YmVSakt5OHY3d25YMkliZlhrbDFMeGxCcTBoYWZwdG9RUnBJcTBJU2hmZnRINjVqUjNNVlFQQ0R5Vks5Zk1BPT0iLCJpdiI6IjZhZTZlZjgyMDM2ZGZjZGQ2MmU2ODRlZjQ4MTNmNzMxIiwicyI6IjZjNGQ2NWM4YWQxOTdiNDgifQ==";
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<User[]>(`/users`);
    }

    getById(id: number) {
        return this.http.get<User>(`/users/${id}`);
    }
    /*************************************Admin Service**************************************************************************/
    //Get All Admin
    public getAllAdmin() {
        const resp = this.http.get(`${this.baseUrl}/getAllAdmin?string=${this.key}`);
        return resp;
    }
    public getAdmin() {
        const resp = this.http.get(`${this.baseUrl}/getAdmin?string=${this.key}`);
        return resp;
    }
    public addAdmin(admin_add_det:AddAdminDetails){
        return this.http.post(`${this.baseUrl}/createAdmin?string=${this.key}`,admin_add_det); 
    }
    //Delete Admin
    public deleteAdmin(admin_id:AdminID){
        return this.http.post(`${this.baseUrl}/deleteAdmin?string=${this.key}`,admin_id); 
    }
    //Update Detail
    public updateAdmin(admin_update_det:UpdateAdminDetails){
        return this.http.post(`${this.baseUrl}/updateAdmin?string=${this.key}`,admin_update_det).subscribe((result)=>console.log(result)); 
    }
    public updateProfile(admin_update_profile:UpdateProfile){
        return this.http.post(`${this.baseUrl}/updateProfile?string=${this.key}`,admin_update_profile).subscribe((result)=>console.log(result)); 
    }
    public updatePassword(admin_update_password:UpdateAdminPassword){
        return this.http.post(`${this.baseUrl}/updatePassword?string=${this.key}`,admin_update_password);
    }
    public getPincodeStateCity(admin_add_det:AddAdminDetails){
        return this.http.post(`${this.baseUrl}/getPincodeStateCity?string=${this.key}`,admin_add_det); 
    }
    /***********************************************************************************************************************************/
    /*************************************Subscription Service**************************************************************************/
    public getAllSubscription() {
        const resp = this.http.get(`${this.baseUrl}/getAllSubscription?string=${this.key}`);
        return resp;
    }
    public getAllUserSubscription() {
        const resp = this.http.get(`${this.baseUrl}/getUserSubscriptionDetail?string=${this.key}`);
        return resp;
    }
    public getSubscription() {
        const resp = this.http.get(`${this.baseUrl}/getSubscription?string=${this.key}`);
        return resp;
    }
    public addSubscription(subscription_add_det:AddSubscriptionDetails){
        return this.http.post(`${this.baseUrl}/createSubscription?string=${this.key}`,subscription_add_det); 
    }
    public updateSubscription(subscription_update_det:UpdateSubscriptionDetails){
        return this.http.post(`${this.baseUrl}/updateSubscription?string=${this.key}`,subscription_update_det).subscribe((result)=>console.log(result)); 
    }
    public deleteSubscription(subscription_id:SubscriptionID){
        return this.http.post(`${this.baseUrl}/deleteSubscription?string=${this.key}`,subscription_id); 
    }
    /***********************************************************************************************************************************/

    /*************************************User Service**************************************************************************/
    //Get All Admin
    public getAllUser() {
        const resp = this.http.get(`${this.baseUrl}/getAllUsers?string=${this.key}`);
        return resp;
    }
    //Get Approved User
    public getApprovedUser() {
        const resp = this.http.get(`${this.baseUrl}/getApprovedUser?string=${this.key}`);
        return resp;
    }

    public getToken(id) {
        const resp = this.http.get(`${this.baseUrl}/getdata?string=${this.key}&id=${id}`);
        return resp;
    }

    public changeStatus(c_status:ChangeStatus){
        return this.http.post(`${this.baseUrl}/changeStatus?string=${this.key}`,c_status); 
    }
    //Approve User
    public approveUser(user_id:UserID){
        return this.http.post(`${this.baseUrl}/approveUser?string=${this.key}`,user_id); 
    }
    public rejectUser(data:any){
        return this.http.post(`${this.baseUrl}/rejectUser?string=${this.key}`,data); 
    }
    public createUserSubscription(s_id:any){
        return this.http.post(`${this.baseUrl}/createUserSubscription?string=${this.key}`,s_id); 
    }
    public createAdminUserSubscription(data){
        return this.http.post(`${this.baseUrl}/createAdminUserSubscription?string=${this.key}`,data); 
    }
    public createUserFreeSubscription(s_id:any){
        return this.http.post(`${this.baseUrl}/createUserFreeSubscription?string=${this.key}`,s_id); 
    }
   /***********************************************************************************************************************************/
   /*************************************Story Service**************************************************************************/
   public getAllStory() {
        const resp = this.http.get(`${this.baseUrl}/getAllStory?string=${this.key}`);
        return resp;
    }
    public addStory(story_add_det:AddStoryDetails){
        return this.http.post(`${this.baseUrl}/createStory?string=${this.key}`,story_add_det); 
    }
    public updateStory(story_update_det:UpdateStoryDetails){
        return this.http.post(`${this.baseUrl}/updateStory?string=${this.key}`,story_update_det).subscribe((result)=>console.log(result)); 
    }
    public deleteStory(story_id:StoryID){
        return this.http.post(`${this.baseUrl}/deleteStory?string=${this.key}`,story_id); 
    }
    /***********************************************************************************************************************************/
    /*************************************Dashboard Service**************************************************************************/
    public getTotalMembers() {
        const resp = this.http.get(`${this.baseUrl}/getTotalMembers?string=${this.key}`);
        return resp;
    }
    public getTotalApprovedMembers() {
        const resp = this.http.get(`${this.baseUrl}/getTotalApprovedMembers?string=${this.key}`);
        return resp;
    }
    public getPendingApprovalMembers() {
        const resp = this.http.get(`${this.baseUrl}/getPendingApprovalMembers?string=${this.key}`);
        return resp;
    }
    public getTotalStories() {
        const resp = this.http.get(`${this.baseUrl}/getTotalStories?string=${this.key}`);
        return resp;
    }
    public getTotalEarning() {
        const resp = this.http.get(`${this.baseUrl}/getTotalEarning?string=${this.key}`);
        return resp;
    }
    //Transaction
    public getAllTransaction() {
        const resp = this.http.get(`${this.baseUrl}/getAllTransaction?string=${this.key}`);
        return resp;
    }
    //Export Excel
    public downloadStory() {
        const resp = this.http.get(`${this.baseUrl}/downloadStory`);
        return resp;
    }
}